// extracted by mini-css-extract-plugin
module.exports = {"Container":"PullRequest_Container__2-57v","NoPreview":"PullRequest_NoPreview__1zpd3","PanelHeader":"PullRequest_PanelHeader__29Wl-","Summary":"PullRequest_Summary__3471W"};